<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 256 256"
  [innerHTML]="svgContent()">
</svg>
